import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { SessionStorageService } from "ngx-webstorage";
import { Observable } from "rxjs";
import { AppState } from "../app.service";
import { BlobStorageService } from "../cms-editor/services/api-services/cms-blob.service";
import { SharingServices } from "../cms-editor/services/sharing-service";

@Injectable({
    providedIn: 'root'
})
export class SamlService {
    constructor(private readonly router: Router,
        private readonly appState: AppState,
        private readonly blobservice: BlobStorageService,
        private readonly sharing: SharingServices,
        private readonly _sessionStore: SessionStorageService) {
        this.updateSession = this.updateSession.bind(this);
    }

    public handleSessionInitiation(sessionInitCaller: () => Observable<any>): Promise<boolean | Error> {
        const target = this._sessionStore.retrieve('target') || { url: '/home', params: {} };

        return sessionInitCaller().toPromise()
            .then(res => ({ target: target, response: res }))
            .then(this.updateSession).then(_res => {
                this.blobservice.menu('/iac').subscribe({
                    next: (res) => {
                        if (res) {
                            this.sharing.publishToken.next(res);
                        }
                    },
                    error: (err) => console.error('Error Calling Menu', err)
                });
                return _res;
            }).catch(error => {
                const err = error?.cause ? error.cause : error;
                return Promise.reject(err);
            });
    }

    private updateSession(data) {
        if (!data.response.hasOwnProperty('json')) {
            data.response = this.appState.parseResponse(data.response);
        }
        this.appState.publishSessionChange(data.response);
        return this.router.navigate([data.target.url], { queryParams: data.target.params })
            .then(didNavigate => {
                if (!didNavigate) throw 'Error Initiating Session. Please retry to login';
                return didNavigate;
            });
    }
}
